/* eslint-disable no-case-declarations */
import { actionTypes } from '../actions/app'

const initial = {
  translations: {},
  language: 'es',
  category_types: [],
  sectors: []
}

export default (state = initial, action) => {

  // Get token from local Storage
   switch (action.type) {
    case actionTypes.SET_TRANSLATIONS:
      return {
        ...state,
        translations: { ...action.data.translations },
        language: action.data.language,
      }
    case actionTypes.RECEIVE_CATEGORY_TYPES:
      const category_types = []
      for (var i in action.data ){
        let aux = { name: action.data[i].name, id: action.data[i].id }
        category_types.push(aux)
      }
      return Object.assign({}, state, {
        category_types: category_types
      })
    case actionTypes.RECEIVE_SECTORS:
      return { ...state, sectors: action.data.data }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/app.js